
/* START_TEMPLATE */
define('hbs!templates/layouts/content',['hbs','hbs/handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers);
  


  return "<div id=\"headerRegion\"></div>\n<div class=\"container-fluid sig-container-wrap\">    \n    <div id=\"mainRegion\"></div>\n</div>";
  });
Handlebars.registerPartial('templates/layouts/content', t);
return t;
});
/* END_TEMPLATE */
;
